import { HTMLAttributes, forwardRef } from 'react';

// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import { Theme, WithStyles, createStyles, withStyles } from '@material-ui/core';

import classNames from 'classnames';

import { InputGroupContext } from './InputGroupContext';

const styles = (theme: Theme) => {
  const outlinedResting = theme.palette.type === 'dark' ? '#a7A7A7' : '#6a6a6a';

  return createStyles({
    root: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'start',
      gap: theme.spacing(1),
      padding: theme.spacing(1),
      boxShadow: `0 0 0 1px ${outlinedResting} inset`,
      borderRadius: theme.spacing(0.5),

      '&:has([data-slot="input"]:focus)': {
        boxShadow: `inset 0 0 0 2px ${theme.palette.border}`,
      },

      '& > [data-slot="input"]': {
        marginTop: 2,
      },

      '&:not($disabled):not(:has([data-slot="input"]:focus)):hover': {
        boxShadow: `inset 0 0 0 1px ${theme.palette.border}`,
      },
      '&.Mui-focused': {
        boxShadow: `inset 0 0 0 2px ${theme.palette.border}`,
      },
      '&.Mui-error': {
        boxShadow: `0 0 0 1px ${theme.palette.error.main} inset`,
      },

      transition: theme.transitions.create(['box-shadow'], {
        duration: 100,
        easing: 'ease-out',
      }),
    },
    disabled: {
      opacity: 0.5,
    },
  });
};

export interface InputGroupRootProps
  extends HTMLAttributes<HTMLDivElement>,
    WithStyles<typeof styles> {
  disabled?: boolean;
}

const InputGroupRoot = forwardRef<HTMLDivElement, InputGroupRootProps>(
  ({ children, className, classes, disabled = false, ...rest }, ref) => {
    return (
      <InputGroupContext.Provider value={{ disabled }}>
        <div
          ref={ref}
          className={classNames(
            classes.root,
            { [classes.disabled]: disabled },
            className,
          )}
          {...rest}
        >
          {children}
        </div>
      </InputGroupContext.Provider>
    );
  },
);

InputGroupRoot.displayName = 'InputGroup.Root';

export default withStyles(styles)(InputGroupRoot);
